
import {
    MobileMenuItem,
    MobileMenuItems
} from "@web-libs/features/navigation/mobile-menu-items";
import {useTageaRouter} from "@web-libs/core/routing/application/use-tagea-router.concern";
import {routes} from "@web-app/[lang]/[tenant]/[institution]/routes-institution";
import {useAuth} from "@web-libs/features/auth/main/application/use-auth.concern";
import {useDictionaryContext} from "@web-libs/core/internationalization/dictionary.context";

export const PublicMobileMenu = ({close}: { close: () => void }) => {
    const dictMenu = useDictionaryContext().menu
    const router = useTageaRouter()
    const auth = useAuth()

    const items: MobileMenuItem[] = [
        {
            name: dictMenu.login, onClick: () => {
                auth.requestLogin()
            }
        },
        {
            name: dictMenu.register, onClick: () => {
                router.push(routes.registration)
            }
        },
    ]

    return (
        <MobileMenuItems items={items} close={close}></MobileMenuItems>
    )
}
